import { hairSrc } from "./faceReading.js";

export const FAMILY_VARIANT_COUNT = 4;

const variant = (id, name, image, detail, length = "medium") => ({
  id,
  name,
  image,
  detail,
  length,
});

export const STYLE_FAMILIES = [
  {
    id: "men-curtain",
    gender: "pria",
    name: "Fringe & Sweep",
    summary: "Poni air dan sapuan ke kiri atau kanan.",
    shapes: { oval: 5, oblong: 5, heart: 4, diamond: 4, round: 3, square: 3 },
    variants: [
      variant("men-curtain-classic", "Air", "snap-air_bang.jpg", "Poni air tipis dengan belahan tengah."),
      variant("men-comma-hair", "Left sweep", "snap-side_swept_bang_left.jpg", "Poni disapu ke kiri."),
      variant("men-textured-curtain", "Right sweep", "snap-side_swept_bang_right.jpg", "Poni disapu ke kanan."),
      variant("men-wavy-curtain", "Wispy", "snap-wispy_bang.jpg", "Poni tipis yang terpisah-pisah di dahi."),
    ],
  },
  {
    id: "men-wolf",
    gender: "pria",
    name: "Gelombang & Ikal",
    summary: "Wave dan ikal dengan volume terkendali.",
    shapes: { oval: 5, oblong: 4, diamond: 5, square: 4, heart: 3, round: 3 },
    variants: [
      variant("men-wolf-medium", "Wavy 1", "snap-wavy.jpg", "Gelombang natural di sepanjang rambut."),
      variant("men-wolf-wavy", "Wavy 2", "snap-k_wavy.jpg", "Gelombang lebih tegas, mirip hasil wave salon."),
      variant("men-wolf-curly", "Curls", "snap-curls.jpg", "Ikal sepanjang rambut, volume terkendali."),
      variant("men-wolf-mullet", "Long", "snap-long.jpg", "Rambut panjang dengan sedikit gerakan di ujung.", "long"),
    ],
  },
  {
    id: "men-korean-curl",
    gender: "pria",
    name: "Soft & Straight",
    summary: "Tekstur lembut sampai lurus rapi.",
    shapes: { oval: 5, oblong: 5, square: 4, heart: 4, diamond: 3, round: 3 },
    variants: [
      variant("men-korean-wave-perm", "Soft", "snap-soft.jpg", "Rambut lembut dengan volume ringan, tanpa poni tebal."),
      variant("men-korean-volume-perm", "Straight", "snap-straight.jpg", "Rambut lurus rapi, panjang sedang sampai panjang.", "long"),
      variant("men-korean-comma-perm", "Fix hair part", "snap-hair_part_fixing.jpg", "Merapikan belahan; potongan tetap dekat dengan rambut asli."),
      variant("men-korean-curly-fringe", "Choppy", "snap-choppy_bang.jpg", "Poni bertekstur pecah, tidak rata."),
    ],
  },
  {
    id: "men-crop",
    gender: "pria",
    name: "Poni",
    summary: "Poni penuh, blunt, dan C-shaped.",
    shapes: { round: 5, oval: 5, square: 5, heart: 3, diamond: 4, oblong: 4 },
    variants: [
      variant("men-crop-textured", "Bangs", "snap-bang.jpg", "Poni penuh yang menutupi dahi."),
      variant("men-crop-french", "Full Blunt", "snap-full_blunt_bang.jpg", "Poni blunt penuh, garis rata di dahi."),
      variant("men-crop-messy", "Light Blunt", "snap-light_blunt_bang.jpg", "Poni blunt lebih tipis dari full blunt."),
      variant("men-crop-caesar", "C shaped", "snap-bobcut_with_bang.jpg", "Bob C-shaped dengan poni ke depan.", "bob"),
    ],
  },
  {
    id: "men-side-part",
    gender: "pria",
    name: "Belahan Samping",
    summary: "Sapuan samping dan belahan rapi.",
    shapes: { oval: 5, square: 5, heart: 4, oblong: 5, diamond: 4, round: 3 },
    variants: [
      variant("men-side-classic", "Left sweep", "snap-side_swept_bang_left.jpg", "Poni disapu ke kiri."),
      variant("men-side-natural", "Right sweep", "snap-side_swept_bang_right.jpg", "Poni disapu ke kanan."),
      variant("men-side-low-taper", "Fix hair part", "snap-hair_part_fixing.jpg", "Merapikan belahan; potongan tetap dekat dengan rambut asli."),
      variant("men-side-swept", "Straight", "snap-straight.jpg", "Rambut lurus rapi, panjang sedang sampai panjang.", "long"),
    ],
  },
  {
    id: "men-crew-buzz",
    gender: "pria",
    name: "Natural Texture",
    summary: "Soft, wave, lurus, dan ikal.",
    shapes: { oval: 5, round: 4, square: 5, heart: 3, diamond: 3, oblong: 2 },
    variants: [
      variant("men-crew-classic", "Soft", "snap-soft.jpg", "Rambut lembut dengan volume ringan, tanpa poni tebal."),
      variant("men-crew-taper", "Wavy 1", "snap-wavy.jpg", "Gelombang natural di sepanjang rambut."),
      variant("men-buzz-classic", "Straight", "snap-straight.jpg", "Rambut lurus rapi, panjang sedang sampai panjang.", "long"),
      variant("men-crew-textured", "Curls", "snap-curls.jpg", "Ikal sepanjang rambut, volume terkendali."),
    ],
  },
  {
    id: "women-curtain",
    gender: "wanita",
    name: "Poni Air & Wispy",
    summary: "Poni air, wispy, dan choppy.",
    shapes: { oval: 5, oblong: 5, heart: 5, diamond: 5, square: 4, round: 3 },
    variants: [
      variant("women-curtain-classic", "Air", "snap-air_bang.jpg", "Poni air tipis dengan belahan tengah."),
      variant("women-curtain-face-frame", "Air (denser)", "snap-air_denser_bang.jpg", "Poni air lebih tebal di sekitar dahi."),
      variant("women-curtain-long", "Wispy", "snap-wispy_bang.jpg", "Poni tipis yang terpisah-pisah di dahi."),
      variant("women-curtain-bob", "Choppy", "snap-choppy_bang.jpg", "Poni bertekstur pecah, tidak rata."),
    ],
  },
  {
    id: "women-wolf",
    gender: "wanita",
    name: "Poni Blunt",
    summary: "Poni rata dan bob C-shaped.",
    shapes: { oval: 5, square: 5, heart: 4, diamond: 4, round: 4, oblong: 3 },
    variants: [
      variant("women-wolf-soft", "Full Blunt", "snap-full_blunt_bang.jpg", "Poni blunt penuh, garis rata di dahi."),
      variant("women-wolf-wavy", "Light Blunt", "snap-light_blunt_bang.jpg", "Poni blunt lebih tipis dari full blunt."),
      variant("women-wolf-lob", "Bangs", "snap-bang.jpg", "Poni penuh yang menutupi dahi."),
      variant("women-wolf-long", "C shaped", "snap-bobcut_with_bang.jpg", "Bob C-shaped dengan poni ke depan.", "bob"),
    ],
  },
  {
    id: "women-korean-curl",
    gender: "wanita",
    name: "Gelombang & Ikal",
    summary: "Wavy, curls, dan curly bob.",
    shapes: { oval: 5, square: 5, oblong: 5, heart: 4, diamond: 4, round: 3 },
    variants: [
      variant("women-korean-c-curl", "Curls", "snap-curls.jpg", "Ikal sepanjang rambut, volume terkendali."),
      variant("women-korean-s-curl", "Wavy 2", "snap-k_wavy.jpg", "Gelombang lebih tegas, mirip hasil wave salon."),
      variant("women-korean-loose", "Wavy 1", "snap-wavy.jpg", "Gelombang natural di sepanjang rambut."),
      variant("women-korean-long", "Curly Bob", "snap-curly_bob.jpg", "Bob pendek berikal.", "bob"),
    ],
  },
  {
    id: "women-bob",
    gender: "wanita",
    name: "Bob",
    summary: "Bob lurus, French, flippy, dan bendy.",
    shapes: { oval: 5, oblong: 5, heart: 5, diamond: 4, square: 4, round: 3 },
    variants: [
      variant("women-bob-classic", "Bobcut", "snap-bobcut.jpg", "Bob dagu lurus tanpa poni.", "bob"),
      variant("women-bob-soft", "French Bob", "snap-french_bob.jpg", "French bob pendek dengan poni.", "bob"),
      variant("women-bob-swept", "Flippy Bob", "snap-flippy_bob.jpg", "Bob dengan ujung terbuka ke luar.", "bob"),
      variant("women-bob-textured", "Bendy Bob", "snap-bendy_bob.jpg", "Bob dengan ujung yang melengkung lembut.", "bob"),
    ],
  },
  {
    id: "women-layered",
    gender: "wanita",
    name: "Panjang & Lurus",
    summary: "Long, straight, soft, dan braided.",
    shapes: { round: 5, square: 5, heart: 5, oval: 5, diamond: 4, oblong: 4 },
    variants: [
      variant("women-layered-butterfly", "Long", "snap-long.jpg", "Rambut panjang dengan sedikit gerakan di ujung.", "long"),
      variant("women-layered-long", "Straight", "snap-straight.jpg", "Rambut lurus rapi, panjang sedang sampai panjang.", "long"),
      variant("women-layered-face", "Soft", "snap-soft.jpg", "Rambut lembut dengan volume ringan, tanpa poni tebal."),
      variant("women-layered-wave", "Braided", "snap-braided.jpg", "Gaya kepang di atas rambut yang diikat ke belakang."),
    ],
  },
  {
    id: "women-pixie",
    gender: "wanita",
    name: "Side Sweep",
    summary: "Poni disapu samping dan belahan rapi.",
    shapes: { oval: 5, heart: 5, diamond: 5, square: 4, round: 4, oblong: 3 },
    variants: [
      variant("women-pixie-classic", "Left sweep", "snap-side_swept_bang_left.jpg", "Poni disapu ke kiri."),
      variant("women-pixie-soft", "Right sweep", "snap-side_swept_bang_right.jpg", "Poni disapu ke kanan."),
      variant("women-pixie-textured", "Fix hair part", "snap-hair_part_fixing.jpg", "Merapikan belahan; potongan tetap dekat dengan rambut asli."),
      variant("women-pixie-fringe", "Air", "snap-air_bang.jpg", "Poni air tipis dengan belahan tengah."),
    ],
  },
];

function familyScore(family, reading) {
  if (!reading) return 0;
  const primary = family.shapes?.[reading.shape] || 0;
  const secondary = family.shapes?.[reading.secondary] || 0;
  return primary * 2 + secondary;
}

let liveFamilies = STYLE_FAMILIES;

export function setStyleFamilies(families) {
  if (Array.isArray(families) && families.length) liveFamilies = families;
}

export function currentStyleFamilies() {
  return liveFamilies;
}

export function recommendStyleFamilies(reading, gender = "wanita") {
  const families = liveFamilies
    .filter((family) => family.gender === gender)
    .sort((a, b) => familyScore(b, reading) - familyScore(a, reading) || a.name.localeCompare(b.name));
  const aiIds = reading?.aiFamilyIds || [];
  const aiPicked = aiIds.map((id) => families.find((family) => family.id === id)).filter(Boolean);
  return [...aiPicked, ...families.filter((family) => !aiPicked.includes(family))];
}

export function styleVariantImage(style) {
  if (style?.imageUrl) return style.imageUrl;
  return hairSrc(style?.image || "style-crop.jpg");
}

export function allStyleVariants() {
  return liveFamilies.flatMap((family) => family.variants || []);
}
